import ContentCopy from "@mui/icons-material/ContentCopy";
import { Alert, Button } from "@mui/material";
import * as React from "react";
import { useListContext } from "react-admin";
import styles from "../../../styles/style.module.scss";
import configData from "./../../../config.json";

interface Document {
  id: string;
  userId: string;
  fileName: string;
  link: string;
  s3path: string;
  createdAt: string;
  sharedAt: string;
}

interface ApiResponse {
  count: number;
  docs: Document[];
}

// Кнопка копирования ссылок
export const CopyLinksButton: React.FC = () => {
  const { data } = useListContext();
  const [open, setOpen] = React.useState(false);
  const [fadeOut, setFadeOut] = React.useState(false);

  const handleCopyLinks = () => {
    const token = localStorage.getItem("jwttoken");

    try{
      const text = new ClipboardItem({
          "text/plain": fetch(`${configData.ServerUrl}/getlinks`, {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            return response.json();
          })
          .then((data: ApiResponse) => {
            const links = data.docs.map((record) => record.link).join("\n");
            return new Blob([links], { type: "text/plain" });
          })
      })
      navigator.clipboard.write([text]).then(() => {
        setOpen(true);
        setTimeout(() => {
          setFadeOut(true);
          setTimeout(() => {
            setOpen(false);
            setFadeOut(false);
          }, 1000);
        }, 3000);
      });
    } catch {

        fetch(`${configData.ServerUrl}/getlinks`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            return response.json();
          })
          .then((data: ApiResponse) => {
            const links = data.docs.map((record) => record.link).join("\n");
            navigator.clipboard
              .writeText(links)
              .then(() => {
                setOpen(true);
                // Установить таймер для автоматического закрытия
                setTimeout(() => {
                  setFadeOut(true);
                  setTimeout(() => {
                    setOpen(false);
                    setFadeOut(false);
                  }, 1000); // Время анимации совпадает с временем fadeOut анимации
                }, 3000); // Держим алерт открытым 3 секунды
              })
              .catch((err) => {
                console.error("Failed to copy links: ", err);
              });
          });

      }
  };

  const handleClose = () => {
    setFadeOut(true);
    setTimeout(() => {
      setOpen(false);
      setFadeOut(false);
    }, 1000); // Время анимации совпадает с временем fadeOut анимации
  };

  return (
    <>
      <Button
        style={{ height: 25 }}
        size="small"
        onClick={handleCopyLinks}
        endIcon={<ContentCopy />}
      >
        Скопировать ссылки
      </Button>
      {open && (
        <Alert
          className={`${styles.alertContainer} ${
            fadeOut ? styles.alertFadeOut : ""
          }`}
          onClose={handleClose}
          severity="success"
        >
          Ссылки скопированы!
        </Alert>
      )}
    </>
  );
};
